export const fontFileExtensions = ["ttf", "otf", "woff", "woff2"];
